//Post save
import { fetchAPI } from "./api";

document.addEventListener("DOMContentLoaded", () => {
  setCommentActionsEvents();

  document.addEventListener("click", function (event) {
    var element = event.target.closest(".post-reactions");
    if (!element) return;

    fetchAPI(element.dataset.linkReactions)
      .catch((error) => console.error("Error fetching reactions:", error));
  });

  document.addEventListener("click", function (event) {
    var element = event.target.closest(".topic-votes-popup");
    if (!element) return;

    fetchAPI(element.dataset.linkVotes)
      .catch((error) => console.error("Error fetching topic votes:", error));
  });
});


function setCommentActionsEvents() {
  let savePostLinks = document.querySelectorAll(".savePostLink");
  let unsavePostLinks = document.querySelectorAll(".unsavePostLink");
  let savePostModal = document.getElementById("savePostModal");
  let unsavePostModal = document.getElementById("unsavePostModal");
  let savePostConfirmBtn = document.getElementById("savePostConfirmBtn");
  let savePostCancelBtn = document.getElementById("savePostCancelBtn");
  let unsavePostConfirmBtn = document.getElementById("unsavePostConfirmBtn");
  let unsavePostCancelBtn = document.getElementById("unsavePostCancelBtn");
  let postId = null;

  // Helper functions — animated show/hide for standalone modals
  let showModal = (modal) => {
    if (!modal) return;
    modal.classList.remove("hidden");
    void modal.offsetHeight; // Force reflow
    modal.style.animation = 'standalone-modal-bg-in 0.2s ease-out both';
    const content = modal.querySelector('.common-box');
    if (content) content.style.animation = 'standalone-modal-content-in 0.28s cubic-bezier(0.16, 1, 0.3, 1) both';
  };
  let hideModal = (modal) => {
    if (!modal || modal.dataset.closing === 'true') return;
    modal.dataset.closing = 'true';
    modal.style.animation = 'standalone-modal-bg-out 0.18s ease-in both';
    const content = modal.querySelector('.common-box');
    if (content) content.style.animation = 'standalone-modal-content-out 0.18s ease-in both';
    setTimeout(() => {
      modal.classList.add("hidden");
      modal.style.animation = '';
      if (content) content.style.animation = '';
      modal.dataset.closing = '';
    }, 200);
  };

  let updateLink = (action, postId) => {
    let saveLink = document.querySelector(`#post-save-${postId} .savePostLink`);
    let unsaveLink = document.querySelector(`#post-save-${postId} .unsavePostLink`);
    if (action === "saved") {
      saveLink.classList.add("hidden");
      saveLink.classList.remove("block");
      unsaveLink.classList.remove("hidden");
      unsaveLink.classList.add("block");
    } else if (action === "save") {
      saveLink.classList.remove("hidden");
      saveLink.classList.add("block");
      unsaveLink.classList.add("hidden");
      unsaveLink.classList.remove("block");
    }

    // Close the dropdown
    let dropdown = saveLink ? saveLink.closest(".popupMenumoreDetailsdrop") : null;
    if (dropdown) {
      hideDropdownAnimated(dropdown);
    }
  };

  // Save Post
  savePostCancelBtn?.addEventListener("click", () => hideModal(savePostModal));
  savePostConfirmBtn?.addEventListener("click", () => {
    fetchAPI("/follow_post", "POST", { post_id: postId }, "json")
      .then((data) => {
        if (data.success) {
          hideModal(savePostModal);
          updateLink("saved", postId);
          let flashMessage = document.createElement("div");
          flashMessage.innerText = I18n.t("post_saved");
          flashMessage.classList.add("fixed", "flex", "bg-secondary-light", "dark:bg-white", "items-center", "w-max", "max-w-[95vw]", "p-4", "space-x-4", "text-primary-text-dark", "divide-x", "rtl:divide-x-reverse", "divide-gray-200", "rounded-lg", "shadow", "md:top-[70px]", "bottom-10", "right-5", "md:bottom-auto", "md:left-auto", "dark:text-primary-text-light", "dark:divide-gray-700", "space-x", "dark:bg-gray-800", "z-40", "slide-in");
          document.body.appendChild(flashMessage);
          setTimeout(() => document.body.removeChild(flashMessage), 3000);
        }
      })
      .catch((error) => console.error("Error:", error));
  });

  // Unsave Post
  unsavePostCancelBtn?.addEventListener("click", () => hideModal(unsavePostModal));
  unsavePostConfirmBtn?.addEventListener("click", () => {
    fetchAPI("/unfollow_post", "POST", { post_id: postId }, "json")
      .then((data) => {
        if (data.success) {
          hideModal(unsavePostModal);
          updateLink("save", postId);
          let flashMessage = document.createElement("div");
          flashMessage.innerText = I18n.t("unsaved_post");
          flashMessage.classList.add("fixed", "flex", "bg-secondary-light", "dark:bg-white", "items-center", "w-max", "max-w-[95vw]", "p-4", "space-x-4", "text-primary-text-dark", "divide-x", "rtl:divide-x-reverse", "divide-gray-200", "rounded-lg", "shadow", "md:top-[70px]", "bottom-10", "right-5", "md:bottom-auto", "md:left-auto", "dark:text-primary-text-light", "dark:divide-gray-700", "space-x", "dark:bg-gray-800", "z-40", "slide-in");
          document.body.appendChild(flashMessage);
          setTimeout(() => document.body.removeChild(flashMessage), 3000);
        }
      })
      .catch((error) => console.error("Error:", error));
  });

  // Set Save/Unsave Event Listeners
  let setSaveComment = () => {
    savePostLinks.forEach((link) => {
      link.addEventListener("click", (event) => {
        event.preventDefault();
        postId = link.dataset.postId;
        showModal(savePostModal);
      });
    });

    unsavePostLinks.forEach((link) => {
      link.addEventListener("click", (event) => {
        event.preventDefault();
        postId = link.dataset.postId;
        showModal(unsavePostModal);
      });
    });
  };

  setSaveComment();

  // Copy Link
  let copyLinks = document.querySelectorAll(".copy-link");
  copyLinks.forEach((link) => {
    link.addEventListener("click", function () {
      let origin = window.location.origin;
      let element = document.getElementById(`copy_to_clipboard_${this.dataset.postId}`);
      let linkStr = element ? `${origin}${element.dataset.link || ''}` : '';
      copyText(linkStr);

      // Close the dropdown
      let dropdown = this.closest(".popupMenumoreDetailsdrop");
      if (dropdown) {
        hideDropdownAnimated(dropdown);
      }
      let footer_copied = this.closest(".comment-footer").querySelector(`#link-copied-${this.dataset.postId}`);
      footer_copied.style.display = "block";
      footer_copied.focus();
      setTimeout(() => {
        fadeOut(footer_copied);
      }, 2000);
    });
  });

  function copyText(text) {
    if (!document.hasFocus()) {
      return;
    }
    window.navigator.clipboard
      .writeText(text)
      .then(() => {})
      .catch((err) => {
        console.error("Unable to copy text: ", err);
      });
  }

  // Reactions - update ALL matching elements (same post can appear in top comments + normal comments)
  var currentUserIdElement = document.getElementById("CurrentUserID");
  if (currentUserIdElement != null) {
    var postReactedElement = document.getElementById("PostReacted");
    if (postReactedElement != null) {
        var reactionsGiven = JSON.parse(postReactedElement.getAttribute('data-reactions-given'));
        reactionsGiven.forEach((reaction) => {
            document.querySelectorAll(".voting_status_" + reaction.post_id).forEach(el => {
              el.innerHTML = `
                <img alt="${reaction.name}" loading="lazy" src="${reaction.reaction_url}" height="20" width="20">
                <span class="text-secondary-text-light dark:text-secondary-text-dark ml-2 md:text-sm text-xs gtm-post-like">${reaction.name}</span>
              `;
            });

            document.querySelectorAll(`.reactions_${reaction.post_id}`).forEach(el => el.remove());

        });
    }
  }
}

// Helper functions for like button behavior
function closeMobileReactions() {
  document.querySelectorAll('.reactions[data-mobile-opened="true"]').forEach(div => {
    div.style.maxWidth = '0px';
    div.classList.remove('active');
    setTimeout(() => {
      div.innerHTML = '';
      div.dataset.loaded = false;
      div.dataset.mobileOpened = '';
      div.classList.add('!hidden');
    }, 100);
  });
}

function showMobileReactions(postId, container) {
  // Reuse existing hover logic from reactions.js
  if (window.showReactionsPopup) {
    window.showReactionsPopup(container, postId);
    // Scope to local container to avoid duplicate ID conflicts
    const reactionsDiv = container.querySelector(`.reactions_${postId}`);
    if (reactionsDiv) {
      reactionsDiv.dataset.mobileOpened = 'true';
    }
  }
}

function upvotePost(postId, reactionId) {
  fetchAPI(`/posts/voteup?id=${postId}&reaction_id=${reactionId}`, "PUT")
    .catch((error) => console.error("Error upvoting:", error));
}

// Like button click handler - desktop vs mobile behavior
document.addEventListener('click', function(event) {
  const isMobile = window.innerWidth < 768;

  // Close mobile-opened containers when clicking outside
  if (isMobile && !event.target.closest('.reactions, .reaction-list, .reaction-icon')) {
    closeMobileReactions();
  }

  const reactionList = event.target.closest('.reaction-list');
  if (!reactionList) return;

  const reactionPopup = reactionList.closest('.reaction-popup');
  if (!reactionPopup) return;

  event.preventDefault();
  event.stopPropagation();

  const postId = reactionPopup.dataset.id;

  if (isMobile) {
    const container = reactionPopup.closest('.reactions-container');
    if (container) showMobileReactions(postId, container);
  } else {
    const reactions = window.appconfig?.reactions;
    const likeReaction = reactions?.find(r => r.id === 1) || reactions?.[0];
    if (likeReaction) upvotePost(postId, likeReaction.id);
  }
});

window.setCommentActionsEvents = setCommentActionsEvents;
